import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';

import { useMst } from '../../../models/rootModel';

import { TabletWidth } from '../../../global.style';
import { useAnalytics } from '../../../utils/analytics';
import { sendGTMEvent } from '../../../utils/googleTagManager';
import { getColor } from '../UICommon';
import { BaseStepPropsV2 } from './BaseStepV2.types';
import { StickyMobileButtonWrapperHeight } from './StepV2MainContent.style';

export const RootBox = styled.div<{ addSpacingNeededForMobileButton: boolean }>`
  font-family: 'Poppins';
  line-height: 20px;
  font-size: 14px;
  color: ${getColor('BLACK_60')};
  font-weight: 400;
  background-color: ${getColor('DARK_CREAM')};

  @media (max-width: ${TabletWidth}px) {
    padding-bottom: ${(props) => (props.addSpacingNeededForMobileButton ? StickyMobileButtonWrapperHeight : 0)}px;
  }
`;

export const Wrapper = styled.div`
  margin: auto;
  width: 100%;
`;

export const BaseStepV2: React.FC<BaseStepPropsV2> = observer((props: BaseStepPropsV2) => {
  const { UserDiscoveryResponse, Step } = useMst();

  const { isActive, title, stepType, addSpacingNeededForMobileButton = true } = props;

  const analytics = useAnalytics();
  const segmentObject = useRef({
    stepId: props.stepName,
    stepType: stepType,
    stepIndex: props.stepIndex,
    stepTitle: props.title,
    ...UserDiscoveryResponse.utms,
    origin: Step.origin,
    userID: UserDiscoveryResponse.accountId,
  });

  useEffect(() => {
    if (isActive) {
      sendGTMEvent({
        event: 'page_view',
        // todo: after we add routing this needs to update
        page_location: `${window.location.href}/${props.stepName}`,
        page_title: `Onboarding - ${title}`,
        user_id: UserDiscoveryResponse.accountId,
      });
    }
  }, [isActive, UserDiscoveryResponse.accountId, title, props.stepName]);

  useEffect(() => {
    if (isActive) {
      analytics.track(`view onboarding step`, { ...segmentObject.current, referringUrl: document.referrer });
    }
  }, [isActive, analytics, segmentObject, stepType]);

  useEffect(() => {
    if (UserDiscoveryResponse.accountId) {
      analytics.identify(UserDiscoveryResponse.accountId);
    }
  }, [UserDiscoveryResponse.accountId, analytics]);

  if (!isActive) {
    return null;
  }

  return (
    <RootBox addSpacingNeededForMobileButton={addSpacingNeededForMobileButton}>
      <Wrapper>{props.children}</Wrapper>
    </RootBox>
  );
});
